<template>
    <router-link
        tag="button"
        class="btn p-0 max-w-full bg-primary border-2 border-darkGrayishBlue"
        :to="{ name: 'product', params: { id: targetProduct.id } }"
    >
        <div class="flex justify-center items-center w-full px-4 py-1">
            <div class="text-darkGrayishBlue font-bold">
                {{
                    $t(
                        'product.smpl.map.' +
                            targetProduct.prodTypeCode.toLowerCase()
                    )
                }}
            </div>
            <div class="icon text-darkGrayishBlue">
                <playArrowSvg />
            </div>
        </div>
    </router-link>
</template>

<script>
import playArrowSvg from '@/assets/svg/play_arrow.svg';
export default {
    components: { playArrowSvg },
    props: {
        targetProduct: { type: Object, default: undefined }
    }
};
</script>
